// extracted by mini-css-extract-plugin
export default {"wrap":"ui_wrap__2KfUa","header":"ui_header__0VfrA"};